module.exports = __webpack_public_path__ + "static/media/3.6f4e70ef.jpeg";